/* istanbul ignore file */

import { FORM_FIELDS } from './form-fields';

export const FORM_PATHS = {
  SEARCH_TERM: () => FORM_FIELDS.SEARCH_TERM,
  SEARCH_TAGS: () => FORM_FIELDS.SEARCH_TAGS,
  SELECT_ALL: () => FORM_FIELDS.SELECT_ALL,
  SEARCH_TAGS_TERM: () => FORM_FIELDS.SEARCH_TAGS_TERM,
  SHOW_ARTICLE_READY_ONLY: () => FORM_FIELDS.SHOW_ARTICLE_READY_ONLY,
  THREE_BY_ONE_FILTER: () => FORM_FIELDS.THREE_BY_ONE_FILTER,
};
